import type { PortableTextBlock } from '@portabletext/types';

export const getH2s = (blocks: Array<PortableTextBlock>) =>
  blocks
    ?.filter((markDef: PortableTextBlock) => markDef?.style === 'h2')
    .map((item: PortableTextBlock) => ({
      text: item.children[0].text as string,
      id: `${item._key}`,
    }));
